const quicklinks = `<!--begin::Quick links-->
<div class="d-flex align-items-center ms-1 ms-lg-3">
    <!--begin::Menu wrapper-->
    <div class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
        <i class="bi bi-clipboard-check fs-2"></i>
    </div>
    <!--begin::Menu-->
    <div class="menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-325px" data-kt-menu="true">
        <!--begin::Heading-->
        <div class="d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10" style="background-image:url('assets/media/misc/pattern-1.jpg')">
            <!--begin::Title-->
            <h3 class="text-white fw-bold mb-3">Quick Links</h3>
            <!--end::Title-->
            <!--begin::Status-->
            <span class="badge bg-primary py-2 px-3">25 pending tasks</span>
            <!--end::Status-->
        </div>
        <!--end::Heading-->
        <!--begin:Nav-->
        <div class="row g-0">
            <!--begin:Item-->
            <div class="col-6">
                <a href="../../demo6/dist/apps/projects/budget.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end border-bottom">
                    <!--begin::Svg Icon | path: icons/duotune/finance/fin009.svg-->
                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M15.8 11.4H6C5.4 11.4 5 11 5 10.4C5 9.80002 5.4 9.40002 6 9.40002H15.8C16.4 9.40002 16.8 9.80002 16.8 10.4C16.8 11 16.3 11.4 15.8 11.4ZM15.7 13.7999C15.7 13.1999 15.3 12.7999 14.7 12.7999H6C5.4 12.7999 5 13.1999 5 13.7999C5 14.3999 5.4 14.7999 6 14.7999H14.8C15.3 14.7999 15.7 14.2999 15.7 13.7999Z" fill="black" />
                            <path d="M18.8 15.5C18.9 15.7 19 15.9 19.1 16.1C19.2 16.7 18.7 17.2 18.4 17.6C17.9 18.1 17.3 18.4999 16.6 18.7999C15.9 19.0999 15 19.2999 14.1 19.2999C13.4 19.2999 12.7 19.2 12.1 19.1C11.5 19 11 18.7 10.5 18.5C10 18.2 9.60001 17.7999 9.20001 17.2999C8.80001 16.8999 8.49999 16.3999 8.29999 15.7999C8.09999 15.1999 7.80001 14.7 7.70001 14.1C7.60001 13.5 7.5 12.8 7.5 12.2C7.5 11.1 7.7 10.1 8 9.19995C8.3 8.29995 8.79999 7.60002 9.39999 6.90002C9.99999 6.30002 10.7 5.8 11.5 5.5C12.3 5.2 13.2 5 14.1 5C15.2 5 16.2 5.19995 17.1 5.69995C17.8 6.09995 18.7 6.6 18.8 7.5C18.8 7.9 18.6 8.29998 18.3 8.59998C18.2 8.69998 18.1 8.69993 18 8.79993C17.7 8.89993 17.4 8.79995 17.2 8.69995C16.7 8.49995 16.5 7.99995 16 7.69995C15.5 7.39995 14.9 7.19995 14.2 7.19995C13.1 7.19995 12.1 7.6 11.5 8.5C10.9 9.4 10.5 10.6 10.5 12.2C10.5 13.3 10.7 14.2 11 14.9C11.3 15.6 11.7 16.1 12.3 16.5C12.9 16.9 13.5 17 14.2 17C15 17 15.7 16.8 16.2 16.4C16.8 16 17.2 15.2 17.9 15.1C18 15 18.5 15.2 18.8 15.5Z" fill="black" />
                        </svg>
                    </span>
                    <!--end::Svg Icon-->
                    <span class="fs-5 fw-bold text-gray-800 mb-0">Accounting</span>
                    <span class="fs-7 text-gray-400">eCommerce</span>
                </a>
            </div>
            <!--end:Item-->
            <!--begin:Item-->
            <div class="col-6">
                <a href="../../demo6/dist/apps/projects/settings.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-bottom">
                    <!--begin::Svg Icon | path: icons/duotune/communication/com010.svg-->
                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 8.725C6 8.125 6.4 7.725 7 7.725H14L18 11.725V12.925L22 9.725L12.6 2.225C12.2 1.925 11.7 1.925 11.4 2.225L2 9.725L6 12.925V8.725Z" fill="black" />
                            <path opacity="0.3" d="M22 9.72498V20.725C22 21.325 21.6 21.725 21 21.725H3C2.4 21.725 2 21.325 2 20.725V9.72498L11.4 17.225C11.8 17.525 12.3 17.525 12.6 17.225L22 9.72498ZM15 11.725H18L14 7.72498V10.725C14 11.325 14.4 11.725 15 11.725Z" fill="black" />
                        </svg>
                    </span>
                    <!--end::Svg Icon-->
                    <span class="fs-5 fw-bold text-gray-800 mb-0">Administration</span>
                    <span class="fs-7 text-gray-400">Console</span>
                </a>
            </div>
            <!--end:Item-->
            <!--begin:Item-->
            <div class="col-6">
                <a href="../../demo6/dist/apps/projects/list.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end">
                    <!--begin::Svg Icon | path: icons/duotune/abstract/abs042.svg-->
                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 21.6C16.6 20.4 9.1 20.3 6.3 21.2C5.7 21.4 5.1 21.2 4.7 20.8L2 18C4.2 15.8 10.8 15.1 15.8 15.8C16.2 18.3 17 20.5 18 21.6ZM18.8 2.8C18.4 2.4 17.8 2.20001 17.2 2.40001C14.4 3.30001 6.9 3.2 5.5 2C6.8 3.3 7.4 5.5 7.7 7.7C9 7.9 10.3 8 11.7 8C15.8 8 19.8 7.2 21.5 5.5L18.8 2.8Z" fill="black" />
                            <path opacity="0.3" d="M21.2 17.3C21.4 17.9 21.2 18.5 20.8 18.9L18 21.6C15.8 19.4 15.1 12.8 15.8 7.8C18.3 7.4 20.4 6.70001 21.5 5.60001C20.4 7.00001 20.2 14.5 21.2 17.3ZM8 11.7C8 9 7.7 4.2 5.5 2L2.8 4.8C2.4 5.2 2.2 5.80001 2.4 6.40001C2.7 7.40001 3.00001 9.2 3.10001 11.7C3.10001 15.5 2.40001 17.6 2.10001 18C3.20001 16.9 5.3 16.2 7.8 15.8C8 14.2 8 12.7 8 11.7Z" fill="black" />
                        </svg>
                    </span>
                    <!--end::Svg Icon-->
                    <span class="fs-5 fw-bold text-gray-800 mb-0">Projects</span>
                    <span class="fs-7 text-gray-400">Pending Tasks</span>
                </a>
            </div>
            <!--end:Item-->
            <!--begin:Item-->
            <div class="col-6">
                <a href="../../demo6/dist/apps/projects/users.html" class="d-flex flex-column flex-center h-100 p-6 bg-hover-light">
                    <!--begin::Svg Icon | path: icons/duotune/finance/fin006.svg-->
                    <span class="svg-icon svg-icon-3x svg-icon-primary mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="black" />
                            <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="black" />
                        </svg>
                    </span>
                    <!--end::Svg Icon-->
                    <span class="fs-5 fw-bold text-gray-800 mb-0">Customers</span>
                    <span class="fs-7 text-gray-400">Latest cases</span>
                </a>
            </div>
            <!--end:Item-->
        </div>
        <!--end:Nav-->
        <!--begin::View more-->
        <div class="py-2 text-center border-top">
            <a href="../../demo6/dist/pages/user-profile/activity.html" class="btn btn-color-gray-600 btn-active-color-primary">View All
            <!--begin::Svg Icon | path: icons/duotune/arrows/arr064.svg-->
            <span class="svg-icon svg-icon-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />
                    <path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />
                </svg>
            </span>
            <!--end::Svg Icon--></a>
        </div>
        <!--end::View more-->
    </div>
    <!--end::Menu-->
    <!--end::Menu wrapper-->
</div>
<!--end::Quick links-->`;

const view = /* html */`
    <!--begin::Container-->
    <div class="container-fluid d-flex align-items-stretch justify-content-between">
        <!--begin::Aside mobile toggle-->
        <div class="d-flex align-items-center d-lg-none ms-n1 me-2" title="Show aside menu">
            <div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_aside_mobile_toggle">
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="black" />
                        <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="black" />
                    </svg>
                </span>
                <!--end::Svg Icon-->
            </div>
        </div>
        <!--end::Aside mobile toggle-->
        <!--begin::Mobile logo-->
        <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
            <a href="/" class="d-lg-none">
                <img alt="Logo" src="assets/media/logos/pdx-logo-3d.png" class="h-30px" />
            </a>
        </div>
        <!--end::Mobile logo-->
        <!--begin::Wrapper-->
        <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
            <!--begin::Navbar-->
            <div class="d-flex align-items-stretch" id="kt_header_nav">
                <!--begin::Menu wrapper-->
                <div class="header-menu align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'50px', '300px': '50px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_header_menu_mobile_toggle" data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">
                    <div class="menu menu-rounded menu-column menu-lg-row menu-active-bg menu-state-primary menu-title-gray-700 menu-arrow-gray-400 fw-semibold my-5 my-lg-0 px-2 px-lg-0 align-items-stretch" id="#kt_header_menu" data-kt-menu="true">
                        <!--<div class="d-flex align-items-center">
                            <a href="" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-facebook-f fs-4"></i>
                            </a>
                        </div>-->
                        <div class="d-flex align-items-center">
                            <a href="https://twitter.com/pdxplaycs16" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-twitter fs-4"></i>
                            </a>
                        </div>
                        <div class="d-flex align-items-center">
                            <a href="https://www.instagram.com/pdxplay/" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-instagram fs-4"></i>
                            </a>
                        </div>
                        <!--<div class="d-flex align-items-center">
                            <a href="#" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-youtube fs-4"></i>
                            </a>
                        </div>-->
                        <div class="d-flex align-items-center">
                            <a href="https://www.twitch.tv/pdxplaycs16" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-twitch fs-4"></i>
                            </a>
                        </div>
                        <div class="d-flex align-items-center">
                            <a href="https://steamcommunity.com/groups/pdxplaycs16" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-4"></i>
                            </a>
                        </div>
                        <div class="d-flex align-items-center">
                            <a href="https://discord.gg/9u4mHsf3dD" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-discord fs-4"></i>
                            </a>
                        </div>
                        <div class="d-flex align-items-center">
                            <a href="ts3server://ts.pdxplay.org" class="btn btn-icon btn-color-gray-600 btn-active-color-white external-handler">
                                <i class="fab fa-teamspeak fs-4"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <!--end::Menu wrapper-->
            </div>
            <!--end::Navbar-->
            <!--begin::Toolbar wrapper-->
            <div class="d-flex align-items-stretch flex-shrink-0 only-logged" id="kt_header_buttons">
                <!--begin::Search-->
                <div class="d-flex align-items-center ms-1 ms-lg-3">
                    <!--begin::Menu- wrapper-->
                    <div id="btn-search" class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px position-relative" title="Search" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="bottom" data-i18n="[title]nav.search;[data-bs-original-title]nav.search" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
                        <i class="bi bi-search fs-2"></i>
                    </div>

                    <div id="user-menu-search" class="menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px" data-popper-placement="bottom-end">  
                        <!--begin::Wrapper-->
                        <div data-kt-search-element="wrapper" class="">
                            <label class="form-label fs-7 fw-normal text-gray-700" data-i18n="friends.searchsug"></label>
                            <!--begin::Form-->
                            <form class="w-100 position-relative mb-6 user-menu-search-form" autocomplete="off">                                
                                <div class="input-group input-group-solid">                                    
                                    <!--begin::Input-->
                                    <input type="text" class="search-input form-control form-control-flush ps-12 text-gray-700 fw-normal" id="user-menu-search-input" name="search" value="" placeholder="" data-kt-search-element="input">
                                    <!--end::Input-->
                                </div>
                                <!--begin::Icon-->
                                <i class="fal fa-search fs-4 text-gray-500 position-absolute top-50 translate-middle-y ms-4"></i>    <!--end::Icon-->

                                <!--begin::Spinner-->
                                <span class="user-menu-search-spinner position-absolute top-50 end-0 translate-middle-y lh-0 me-4 d-none z-index-3" data-kt-search-element="spinner">
                                    <span class="spinner-border h-15px w-15px align-middle text-gray-500"></span>
                                </span>
                                <!--end::Spinner-->

                                <!--begin::Reset-->
                                <span class="user-menu-search-reset btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-4 d-none z-index-3">
                                    <i class="bi bi-x-lg fs-6 p-0"></i>
                                </span>
                                <!--end::Reset-->

                                <!--begin::Toolbar-->
                                <div class="position-absolute top-50 end-0 translate-middle-y d-none" data-kt-search-element="toolbar">
                                    <!--begin::Preferences toggle-->
                                    <div data-kt-search-element="preferences-show" class="btn btn-icon w-20px btn-sm btn-active-color-primary me-1" data-bs-toggle="tooltip" aria-label="Show search preferences" data-bs-original-title="Show search preferences" data-kt-initialized="1">
                                        <i class="ki-outline ki-setting-2 fs-2"></i>        </div>
                                    <!--end::Preferences toggle-->

                                    <!--begin::Advanced search toggle-->
                                    <div data-kt-search-element="advanced-options-form-show" class="btn btn-icon w-20px btn-sm btn-active-color-primary" data-bs-toggle="tooltip" aria-label="Show more search options" data-bs-original-title="Show more search options" data-kt-initialized="1">
                                        <i class="ki-outline ki-down fs-2"></i>        </div>
                                    <!--end::Advanced search toggle-->
                                </div>
                                <!--end::Toolbar-->
                            </form>
                            <!--end::Form-->

                            <!--begin::Separator-->
                            <!--<div class="separator border-gray-200 mb-6"></div>-->
                            <!--end::Separator-->
            
                            <!--begin::Recently viewed-->                        
                            <div class="user-menu-search-results mb-5 d-none">
                                <!--begin::Items-->
                                <div class="scroll-y mh-200px mh-lg-350px">
                                    <!--begin::Category title-->
                                    <div class="d-flex align-items-center pb-5 m-0">
                                        <span class="fs-6 fw-semibold text-muted">Users</span>
                                        <span class="ms-2 badge badge-sm bg-primary"><span class="user-menu-search-results-num"></span> <span class="text-uppercase fs-9">results</span></span>
                                    </div>
                                    <!--end::Category title-->               
                                    <div class="user-menu-search-results-list">
                                    </div>
                                </div>
                                <!--end::Items-->
                            </div>
                            <!--end::Recently viewed-->

                            <!--begin::Recently searched-->
                            <div class="user-menu-search-recent mb-5">
                                <!--begin::Heading-->
                                <div class="d-flex flex-stack fw-semibold mb-2">
                                    <!--begin::Label-->
                                    <span class="text-gray-600 fs-6 me-2">Recently Searched:</span>
                                    <!--end::Label-->
                                </div>
                                <!--end::Heading-->

                                <!--begin::Items-->
                                <div class="scroll-y mh-200px mh-lg-325px user-menu-search-recent-list">
                                    
                                </div>
                                <!--end::Items-->
                            </div>
                            <!--end::Recently viewed-->
                
                            <!--begin::Empty-->
                            <div class="user-menu-search-empty text-center d-none">
                                <!--begin::Icon-->
                                <div class="pt-10 pb-10">
                                    <i class="fad fa-file-search fs-4x opacity-50 text-primary"></i>
                                </div>
                                <!--end::Icon-->

                                <!--begin::Message-->
                                <div class="pb-15 fw-semibold">
                                    <h3 class="text-gray-600 fs-5 mb-2">No result found</h3>
                                    <div class="text-muted fs-7">Please try again with a different query</div>
                                </div>
                                <!--end::Message-->
                            </div>
                            <!--end::Empty-->        
                        </div>
                    <!--end::Preferences-->
                    </div>
                    
                </div>
                <!--end::Search-->

                <!--begin::News-->
                <div class="d-flex align-items-center ms-1 ms-lg-3">
                    <!--begin::Menu- wrapper-->
                    <div id="btn-news" class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px position-relative" title="News" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="bottom" data-i18n="[title]nav.news;[data-bs-original-title]nav.news" data-kt-menu-trigger="click" data-kt-menu-overflow="false" data-kt-menu-permanent="true" data-kt-menu-placement="bottom-end" data-kt-menu-attach="parent">
                        <i class="fal fa-newspaper fs-2"></i>
                        <span id="badge-header-news" class="user-menu-news-badge position-absolute translate-middle badge badge-circle badge-primary d-none" style="width:1.55rem;height:1.55rem;top: 8px;right: -16px;"></span>
                    </div>
                    
                    <div class="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px" id="user-menu-news">
                        <!--begin::Heading-->
                        <div class="d-flex flex-column bgi-no-repeat rounded-top bg-gray-100">
                            <!--begin::Title-->                                   
                            <h3 class="text-gray-700 fw-semibold px-9 mt-8 mb-8">
                                News
                            </h3>
                            <!--end::Title-->
                        </div>

                        <div class="min-h-100px mh-325px my-5 px-8 user-menu-news-list">
                                                
                        </div>

                        <div class="py-3 text-center px-8 bg-gray-100 rounded-bottom">
                            <a href="news" data-navigo class="btn btn-sm btn-color-gray-800 btn-active-color-primary overflow-hidden rounded">View All<i class="ms-2 fas fa-arrow-right fs-7"></i></a>
                        </div>
                    </div>
                    

                </div>
                <!--end::News-->                

                <!--begin::Friends-->
                <div class="d-flex align-items-center ms-1 ms-lg-3 auth-required">
                    <!--begin::Menu- wrapper-->
                    <div id="btn-friends" class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px position-relative" title="Friends" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="bottom" data-i18n="[title]nav.friends;[data-bs-original-title]nav.friends">
                        <i class="bi bi-people fs-2"></i>
                    </div>
                </div>
                <!--end::Friends-->
                <!--begin::Chat-->
                <div class="d-flex align-items-center ms-1 ms-lg-3 auth-required">
                    <!--begin::Menu wrapper-->
                    <div class="btn btn-icon btn-active-light-primary position-relative btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px pulse pulse-success" title="Chat" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="bottom" data-i18n="[title]nav.chat;[data-bs-original-title]nav.chat" id="btn-chat">                        
                        <i class="bi bi-chat-square-dots fs-2"></i>                                                
                    </div>
                    <!--end::Menu wrapper-->
                </div>
                <!--end::Chat-->                
                
                <!--begin::User menu-->
                <div class="d-flex align-items-center ms-3 ms-lg-6 auth-required" id="kt_header_user_menu_toggle">

                    <style>
                        .menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {                            
                            background-color: rgba(27, 27, 27, 0.8);
                        }
                    </style>

                    <!--begin::Menu wrapper-->
                    <div class="cursor-pointer symbol symbol-30px symbol-md-40px user-menu" data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
                        <img class="user-img" src="assets/media/avatars/blank.png" alt="image" />
                    </div>
                    <!--begin::User account menu-->
                    <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-primary menu-state-white fw-bold py-4 fs-6 w-275px" id="user-menu-toggle">
                        <!--begin::Menu item-->
                        <div class="menu-item px-3">
                            <div class="menu-content d-flex align-items-center px-3">
                                <!--begin::Avatar-->
                                <div class="symbol symbol-50px me-5">
                                    <img class="user-img" alt="Logo" src="assets/media/avatars/default.jpg" />
                                </div>
                                <!--end::Avatar-->
                                <!--begin::Username-->
                                <div class="d-flex flex-column text-truncate text-nowrap" style="max-width:160px">
                                    <div class="fw-bolder d-flex align-items-center fs-5 user-nick">
                                    <!--<span class="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">Pro</span>--></div>
                                    <a href="" class="fw-bold text-muted text-hover-primary fs-7 user-steamid text-truncate text-nowrap" style="max-width:160px"></a>
                                </div>
                                <!--end::Username-->
                            </div>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu separator-->
                        <div class="separator my-2"></div>
                        <!--end::Menu separator-->
                        <!--begin::Menu item-->
                        <div class="menu-item px-2">                            
                            <a href="" class="menu-link w-100 user-profile dismiss-user-menu btn btn-flex btn-color-gray-800 btn-active-light btn-active-color-white px-4"><i class="fal fa-address-card fs-5 pe-0 me-3"></i><span class="d-flex flex-column align-items-start">
                            <span class="fs-7 fw-bold text-uppercase" data-i18n="usermenu.profile">My Profile</span></span>
                            </a>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu item-->
                        <div class="menu-item px-2">                            
                            <a href="" class="menu-link w-100 user-settings dismiss-user-menu btn btn-flex btn-color-gray-800 btn-active-light btn-active-color-white px-4"><i class="fal fa-cogs fs-5 pe-0 me-3"></i><span class="d-flex flex-column align-items-start">
                            <span class="fs-7 fw-bold text-uppercase" data-i18n="usermenu.settings">Settings</span></span>
                            </a>
                        </div>
                        <!--end::Menu item-->

                        <!--begin::Menu separator-->
                         <div class="separator my-2"></div>
                         <!--end::Menu separator-->
                         <!--begin::Menu item-->
                        <div class="menu-item px-2">                            
                            <a href="logout" class="menu-link w-100 dismiss-user-menu btn btn-flex btn-color-gray-800 btn-active-light btn-active-color-white px-4"><i class="fal fa-sign-out-alt fs-5 pe-0 me-3"></i><span class="d-flex flex-column align-items-start">
                            <span class="fs-7 fw-bold text-uppercase" data-i18n="usermenu.logout">Sign Out</span></span>
                            </a>
                        </div>
                        <!--end::Menu item-->
                                             
                    </div>
                    <!--end::User account menu-->
                    <!--end::Menu wrapper-->
                </div>
                <!--end::User menu-->
                <!--begin::Heaeder menu toggle-->
                <div class="d-flex align-items-center d-lg-none ms-2" title="Show header menu">
                    <div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_header_menu_mobile_toggle">
                        <!--begin::Svg Icon | path: icons/duotune/text/txt001.svg-->
                        <span class="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M13 11H3C2.4 11 2 10.6 2 10V9C2 8.4 2.4 8 3 8H13C13.6 8 14 8.4 14 9V10C14 10.6 13.6 11 13 11ZM22 5V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4V5C2 5.6 2.4 6 3 6H21C21.6 6 22 5.6 22 5Z" fill="black" />
                                <path opacity="0.3" d="M21 16H3C2.4 16 2 15.6 2 15V14C2 13.4 2.4 13 3 13H21C21.6 13 22 13.4 22 14V15C22 15.6 21.6 16 21 16ZM14 20V19C14 18.4 13.6 18 13 18H3C2.4 18 2 18.4 2 19V20C2 20.6 2.4 21 3 21H13C13.6 21 14 20.6 14 20Z" fill="black" />
                            </svg>
                        </span>
                        <!--end::Svg Icon-->
                    </div>
                </div>
                <!--end::Heaeder menu toggle-->
            </div>
            <!--end::Toolbar wrapper-->
        </div>
        <!--end::Wrapper-->
    </div>
    <!--end::Container-->
    
`;

export default view;
